<template>
  <section class="pageContents">
    <div class="pageContents-text container">
      <Assets />
    </div>
  </section>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import Assets from '@/components/assets.vue';

@Options({
    name: 'AssetsView',
    components: {
        Assets,
    },
    props: {
      msg: String
    },
    emits: {
        //select: (myProperty: string) => typeof myProperty === 'string'
    },
  })
export default class AssetsView extends Vue {}
</script>
